(function HotelEngineProviderRules($, Adzuki) {
	'use strict';

	Adzuki.HotelEngine = Adzuki.HotelEngine || {};

	Adzuki.HotelEngine.PROVIDERS = [
		'expedia',
		'expediaBase',
		'hotelBeds',
		'priceline',
		'sabre',
		'tbo',
		'webbeds',
		'bedsonline',
		'agoda'
	];

	Adzuki.HotelEngine.PROVIDER_LABELS = {
		expedia    : 'Expedia',
		expediaBase: 'Expedia Base',
		hotelBeds  : 'HotelBeds',
		bedsOnline : 'HotelBeds',
		priceline  : 'Priceline',
		sabre      : 'Sabre',
		tbo        : 'TBO',
		webbeds    : 'Webbeds',
		agoda      : 'Agoda'
	};

	Adzuki.HotelEngine.PROVIDER_KEY_MAP = {
		expedia     : 'expedia',
		expedia_base: 'expediaBase',
		expediabase : 'expediaBase',
		hotelbeds   : 'hotelBeds',
		hotel_beds  : 'hotelBeds',
		bedsonline  : 'hotelBeds',
		priceline   : 'priceline',
		sabre       : 'sabre',
		tbo         : 'tbo',
		webbeds     : 'webbeds',
		agoda       : 'agoda'
	};

	Adzuki.HotelEngine.providerConfig = {
		expedia: {
			guest: {
				childrenPerRoom: false,
				childrenAges   : false,
				adultDetails   : {
					required: true,
					scope   : 'firstGuestOnly'
				},
				childDetails      : false,
				adultTitlePrefixes: false,
				childTitlePrefixes: false,
			},
		},

		expediaBase: {
			guest: {
				childrenPerRoom: false,
				childrenAges   : false,
				adultDetails   : {
					required: true,
					scope   : 'firstGuestOnly'
				},
				childDetails      : false,
				adultTitlePrefixes: false,
				childTitlePrefixes: false,
			},
		},

		hotelBeds: {
			guest: {
				childrenPerRoom: true,
				childrenAges   : true,
				adultDetails   : {
					required: true,
					scope   : 'allGuests'
				},
				childDetails      : false,
				adultTitlePrefixes: true,
				childTitlePrefixes: true,
			},
		},

		priceline: {
			guest: {
				childrenPerRoom: false,
				childrenAges   : false,
				adultDetails   : {
					required: true,
					scope   : 'firstGuestOnly'
				},
				childDetails      : false,
				adultTitlePrefixes: false,
				childTitlePrefixes: false,
			},
		},

		sabre: {
			guest: {
				childrenPerRoom: false,
				childrenAges   : false,
				adultDetails   : {
					required: true,
					scope   : 'firstGuestOnly'
				},
				childDetails      : false,
				adultTitlePrefixes: false,
				childTitlePrefixes: false,
			},
		},

		tbo: {
			guest: {
				childrenPerRoom: false,
				childrenAges   : false,
				adultDetails   : {
					required: true,
					scope   : 'allGuests'
				},
				childDetails      : true,
				adultTitlePrefixes: true,
				childTitlePrefixes: true,
			},
		},

		webbeds: {
			guest: {
				childrenPerRoom: false,
				childrenAges   : false,
				adultDetails   : {
					required: true,
					scope   : 'allGuests'
				},
				childDetails      : true,
				adultTitlePrefixes: true,
				childTitlePrefixes: true,
			},
		},

		agoda: {
			guest: {
				childrenPerRoom: false,
				childrenAges   : false,
				adultDetails   : {
					required: true,
					scope   : 'allGuests'
				},
				childDetails      : true,
				adultTitlePrefixes: true,
				childTitlePrefixes: true,
			},
		},
	};

	Adzuki.HotelEngine.DEFAULT_GUEST_RULES = {
		childrenPerRoom: false,
		childrenAges   : false,
		adultDetails   : {
			required: true,
			scope   : 'firstGuestOnly'
		},
		childDetails      : false,
		adultTitlePrefixes: false,
		childTitlePrefixes: false,
	};

	Adzuki.HotelEngine.normalizeProviderKey = function normalizeProviderKey(raw) {
		if (!raw || typeof raw !== 'string') {
			return null;
		}

		const normalized = raw.trim().toLowerCase();

		if (Adzuki.HotelEngine.PROVIDER_KEY_MAP[normalized]) {
			return Adzuki.HotelEngine.PROVIDER_KEY_MAP[normalized];
		}

		if (Adzuki.HotelEngine.providerConfig[raw]) {
			return raw;
		}

		console.warn('HotelEngine: unknown provider key:', raw);
		return null;
	};

	// Sabre stores The Hotel Collection as GCD; display it as THC (legacy Hotel Engine).
	Adzuki.HotelEngine.resolveSpecialtyRateCode = function resolveSpecialtyRateCode(code) {
		if (typeof code === 'object' && code !== null) {
			return code.code || null;
		}

		return code || null;
	};

	Adzuki.HotelEngine.displaySpecialtyRateCode = function displaySpecialtyRateCode(code) {
		const rateCode = Adzuki.HotelEngine.resolveSpecialtyRateCode(code);

		return rateCode === 'GCD' ? 'THC' : rateCode;
	};

	Adzuki.HotelEngine.isRuleRequired = function isRuleRequired(rule) {
		if (rule === true) {
			return true;
		}

		if (rule && typeof rule === 'object' && rule.required === true) {
			return true;
		}

		return false;
	};

	Adzuki.HotelEngine.getRuleScope = function getRuleScope(rule) {
		if (rule && typeof rule === 'object' && rule.scope) {
			return rule.scope;
		}

		return 'firstGuestOnly';
	};

	Adzuki.HotelEngine.isGuestFieldRequired = function isGuestFieldRequired(rule, guestIndex, guestType) {
		if (!Adzuki.HotelEngine.isRuleRequired(rule)) {
			return false;
		}

		// A bare `true` rule (e.g. adultTitlePrefixes) applies to every guest.
		if (rule === true) {
			return true;
		}

		const scope = Adzuki.HotelEngine.getRuleScope(rule);

		if (scope === 'allGuests') {
			return true;
		}

		return guestIndex === 0;
	};

	Adzuki.HotelEngine.getProviderRules = function getProviderRules(providerKey) {
		if (!providerKey) {
			return {...Adzuki.HotelEngine.DEFAULT_GUEST_RULES};
		}

		const config = Adzuki.HotelEngine.providerConfig[providerKey];

		if (!config || !config.guest) {
			return {...Adzuki.HotelEngine.DEFAULT_GUEST_RULES};
		}

		return config.guest;
	};

}(jQuery, window.Adzuki || {}));
